import type { SVGProps } from "react";
// generated from Minus.svg — do not edit manually
// prettier-ignore
export default function Minus(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 5 12 H 19" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
